import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MAIN_HOME, COUNTRY_HOMEPAGE } from 'constants/url';
import { Token } from 'states/interface';
import { ConnectState } from 'states/connect';
import generatePath from '@utils/generatePath';
import { qsParse } from '@utils/url-utils';
import Login from './login';
import SignUp from './signup';
import FillInfo from './fill-info';
import { View } from './interface';
import { useTranslation } from 'hooks/use-translation';

type LoginProps = {
	className?: string;
	title?: React.ReactNode;
	onChange(view: View): void;
}
export default function LoginCard(props: LoginProps) {
	const { inviteId = '' } = qsParse();
	const [view, setView] = useState<View>();
	const history = useHistory();
	const token = useSelector((state: ConnectState) => state.app.token);

	useEffect(() => {
		// setView(View.login); // 完善信息页通过菜单退出 重新进入登录视图
		if (inviteId) {
			setView(View.signup)
			return
		}
		setView(history.location?.state === View.signup ? View.signup : View.login);
	}, [history.location?.state, inviteId])

	useEffect(() => {
		if (token?.isRegister) {
			setView(View.fill);
			props.onChange(View.fill);
		} else if (inviteId) {
			setView(View.signup);
		}
	}, [token, inviteId])

	const onChangeView = (view: View, token?: Token) => {
		props.onChange(view);
		if (view === View.fill) {
			if (token?.isRegister) {
				setView(view);
			} else {
				history.replace(generatePath(MAIN_HOME));
			}
			return
		}
		setView(view);
		history.replace({
			state: view,
		})
	}
	// 补全信息完成
	const onFilledHandle = () => {
		history.replace(generatePath(MAIN_HOME));
	}

	if (view === View.login) {
		return <Login {...props} changeView={onChangeView} />
	}
	if (view === View.signup) {
		return <SignUp {...props} changeView={onChangeView} />
	}
	if (view === View.fill) {
		return <FillInfo {...props} onFilled={onFilledHandle} />
	}
	return null;
}
